import { Segmented } from "antd";
import { ReactComponent as SuitingIcon } from "../assets/icons/suiting-icon.svg";
import { ReactComponent as ShirtingIcon } from "./../assets/icons/shirting-icon.svg";

export const SuitingShirtingToggle = ({ value, onChange }) => {
  return (
    <Segmented
      value={value ? "Shirting" : "Suiting"}
      onChange={(val) => onChange(val === "Shirting")}
      options={[
        {
          label: "Suiting",
          value: "Suiting",
          icon: <SuitingIcon className="w-5 h-5" />,
        },
        {
          label: "Shirting",
          value: "Shirting",
          icon: <ShirtingIcon className="w-5 h-5" />,
        },
      ]}
      className="
        !bg-white !border !border-gray-200 !rounded-[14px] !py-1 shadow-sm inline-flex

        [&_.ant-segmented-thumb]:!opacity-0
        [&_.ant-segmented-thumb]:!pointer-events-none

        [&_.ant-segmented-item]:!rounded-[14px] 
        [&_.ant-segmented-item]:!mx-1 
        [&_.ant-segmented-item]:transition-all

        [&_.ant-segmented-item:not(.ant-segmented-item-selected)]:!bg-[#F5E6E6]
        [&_.ant-segmented-item:not(.ant-segmented-item-selected)]:!text-gray-500
        [&_.ant-segmented-item:not(.ant-segmented-item-selected):hover]:!bg-[#eedcdc]

        [&_.ant-segmented-item.ant-segmented-item-selected]:!bg-[#A33434]
        [&_.ant-segmented-item.ant-segmented-item-selected_.ant-segmented-item-label]:!text-white
        [&_.ant-segmented-item.ant-segmented-item-selected_.anticon]:!text-white

        [&_.ant-segmented-item-label]:!flex 
        [&_.ant-segmented-item-label]:!items-center 
        [&_.ant-segmented-item-label]:!justify-center 
        [&_.ant-segmented-item-label]:!gap-1
        [&_.ant-segmented-item-label]:!px-4
        [&_.ant-segmented-item-label]:!py-1.5
        [&_.ant-segmented-item-label]:!font-bold 
        [&_.ant-segmented-item-label]:!h-[42px]
        [&_.ant-segmented-item-label]:text-lg

        [&_.ant-segmented-item-icon]:!mr-0
      "
    />
  );
};
